import { Component, Input, OnInit } from '@angular/core';
import {
  userid_input_data,
  userid_input_types
} from 'src/app/models/util.models';

@Component({
  selector: 'userid-input',
  templateUrl: './userid-input.component.html',
  styleUrls: ['./userid-input.component.css']
})
export class UseridInputComponent implements OnInit {
  @Input('isPrimeNg')
  isPrimeNg: boolean = false;

  @Input('userid_data')
  userid_data: userid_input_data = new userid_input_data(
    userid_input_types.all
  );

  constructor() {}

  ngOnInit(): void {
    // this.userid_data.selected_country_code=this.userid_data.country_codes[0].value;
    // this.userid_data.current_input_type = this.input_type;
  }

  setCountry() {
    if (
      this.userid_data.selected_country_data.acronym in
      this.userid_data.countries_code_3
    ) {
      this.userid_data.selected_country_data =
        this.userid_data.countries_code_3[
          this.userid_data.selected_country_data.acronym
        ];
      this.userid_data.selected_country_acronym =
        this.userid_data.selected_country_data.acronym;
    }
  }

  only_number(event) {
    event = event ? event : window.event;
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
